import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_create-boarding _modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "60",
    height: "61",
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M29.8034 3.88292C15.2228 3.88292 3.36674 15.8238 3.36674 30.501C3.36674 45.1762 15.2228 57.1171 29.8034 57.1171C44.3839 57.1171 56.2452 45.1762 56.2452 30.501C56.2452 15.8238 44.3839 3.88292 29.8034 3.88292ZM29.8034 60.5C13.3737 60.5 0 47.0418 0 30.501C0 13.9582 13.3737 0.5 29.8034 0.5C46.2382 0.5 59.6068 13.9582 59.6068 30.501C59.6068 47.0418 46.2382 60.5 29.8034 60.5Z",
      fill: "#F4C870"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M52.5551 30.5009C52.5551 43.1492 42.3697 53.4025 29.8011 53.4025C17.2376 53.4025 7.05225 43.1492 7.05225 30.5009C7.05225 17.8516 17.2376 7.59787 29.8011 7.59787C42.3697 7.59787 52.5551 17.8516 52.5551 30.5009Z",
      fill: "#F0BB4F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.4438 18.5C23.4438 18.0582 23.088 17.7 22.6491 17.7C22.2102 17.7 21.8544 18.0582 21.8544 18.5V19.3H20.265C18.5094 19.3 17.0862 20.7327 17.0862 22.5V24.1H42.5166V22.5C42.5166 20.7327 41.0934 19.3 39.3378 19.3H37.7484V18.5C37.7484 18.0582 37.3926 17.7 36.9537 17.7C36.5148 17.7 36.159 18.0582 36.159 18.5V19.3H23.4438V18.5ZM42.5166 40.1V25.7H17.0862V40.1C17.0862 41.8673 18.5094 43.3 20.265 43.3H39.3378C41.0934 43.3 42.5166 41.8673 42.5166 40.1ZM32.1855 28.9C31.7466 28.9 31.3908 29.2582 31.3908 29.7V31.3C31.3908 31.7418 31.7466 32.1 32.1855 32.1H33.7749C34.2138 32.1 34.5696 31.7418 34.5696 31.3V29.7C34.5696 29.2582 34.2138 28.9 33.7749 28.9H32.1855ZM36.9537 28.9C36.5148 28.9 36.159 29.2582 36.159 29.7V31.3C36.159 31.7418 36.5148 32.1 36.9537 32.1H38.5431C38.982 32.1 39.3378 31.7418 39.3378 31.3V29.7C39.3378 29.2582 38.982 28.9 38.5431 28.9H36.9537ZM20.265 34.5C20.265 34.0582 20.6208 33.7 21.0597 33.7H22.6491C23.088 33.7 23.4438 34.0582 23.4438 34.5V36.1C23.4438 36.5418 23.088 36.9 22.6491 36.9H21.0597C20.6208 36.9 20.265 36.5418 20.265 36.1V34.5ZM25.8279 33.7C25.389 33.7 25.0332 34.0582 25.0332 34.5V36.1C25.0332 36.5418 25.389 36.9 25.8279 36.9H27.4173C27.8562 36.9 28.212 36.5418 28.212 36.1V34.5C28.212 34.0582 27.8562 33.7 27.4173 33.7H25.8279Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.isOff
						? `Bạn chắc chắn muốn tắt tính năng ${_ctx.featureName}?`
						: `Bạn chắc chắn muốn bật tính năng ${_ctx.featureName}?`), 1),
      _createElementVNode("div", {
        class: "text-center text-neutral-500 mt-2",
        innerHTML: _ctx.isOff ? _ctx.titleNameOff : _ctx.titleNameOn
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, " Huỷ "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Xác nhận ")
    ])
  ]))
}